import { lazy } from "react";
import IRoute from "./IRoute";

const ViewFeedPage = lazy(() => import("../pages/Feed/ViewFeedPage"));

const feedRoutes: IRoute = {
  path: "/feed",
  redirect: "/feed/view",
  children: [
    {
      path: "/view",
      component: ViewFeedPage,
      needAuth: true,
    },
  ],
};

export default feedRoutes;
